import { setSessionDate } from "#src/modules/reducers/session/session.js";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const useSession = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const expiryDate = useSelector((state) => state.session.expiryDate);

  useEffect(() => {
    const excludePages = ["/", "/init", "/flyers"];
    const today = new Date().toLocaleDateString();
    if (!excludePages.includes(location.pathname)) {
      if (!expiryDate) {
        dispatch(setSessionDate({ expiryDate: today }));
      } else if (expiryDate !== today) {
        navigate("/expired");
      }
    } else if (location.pathname === "/") {
      dispatch(setSessionDate({ expiryDate: null }));
    }
  }, [location]);
};

export default useSession;
